<template>
    <!-- 物料商品详情 -->
    <content-view>
        <div class="materiel-detail">
            <a-spin :spinning="spinning">
                <template v-if="$route.params.sysType === 1 || $route.params.sysType === 3">
                    <div class="mb16">
                        <span>创建组织：</span>
                        <span class="text-color-45">{{detail.organizationCreateName || "-"}}</span>
                    </div>
                    <div>
                        <span>使用组织：</span>
                        <span class="text-color-45">{{detail.organizationName || "-"}}</span>
                    </div>
                    <a-divider></a-divider>
                    <div class="font-biggest font-weight text-primary mb16">基本信息：</div>
                    <div class="mb16">
                        <span>物料编码：</span>
                        <span class="text-color-45">{{detail.goodsNo || "-"}}</span>
                    </div>
                    <div class="mb16">
                        <span>物料条形码：</span>
                        <span class="text-color-45">{{detail.goodsBarCode || "-"}}</span>
                    </div>
                    <div class="mb16">
                        <span>物料名称：</span>
                        <span class="text-color-45">{{detail.goodsName || "-"}}</span>
                    </div>
                    <div class="mb16">
                        <span>物料规格：</span>
                        <span class="text-color-45">{{detail.goodsSpecification || "-"}}</span>
                    </div>
                    <div class="mb16">
                        <span>物料分组：</span>
                        <span class="text-color-45">{{detail.goodsGroup || "-"}}</span>
                    </div>
                    <div class="mb16">
                        <span>物料属性：</span>
                        <span class="text-color-45">{{detail.goodsType || "-"}}</span>
                    </div>
                    <div>
                        <span>基本单位：</span>
                        <span class="text-color-45">{{detail.goodsUnit || "-"}}</span>
                    </div>
                    <template v-if="$route.params.sysType === 3">
                        <a-divider></a-divider>
                        <div class="font-biggest font-weight text-primary mb16">库存信息：</div>
                        <div class="mb16">
                            <span>批号：</span>
                            <span class="text-color-45">{{detail.lotName || "-"}}</span>
                        </div>
                        <div class="mb16">
                            <span>仓库：</span>
                            <span class="text-color-45">{{detail.warehouseName || "-"}}</span>
                        </div>
                        <div class="mb16">
                            <span>库存数量：</span>
                            <span class="text-color-45">{{detail.baseQty || "-"}}</span>
                        </div>
                        <div class="mb16">
                            <span>可用数量：</span>
                            <span class="text-color-45">{{detail.baseAvbQty || "-"}}</span>
                        </div>
                        <div class="mb16">
                            <span>库存状态：</span>
                            <span class="text-color-45">{{detail.warehouseStatus || "-"}}</span>
                        </div>
                        <div class="mb16">
                            <span>默认售卖价（元）：</span>
                            <span class="text-color-45">{{detail.basePrice !== null ? detail.basePrice : "-"}}</span>
                        </div>
                        <div>
                            <span>实际售卖价（元）：</span>
                            <span class="text-color-45">{{detail.price !== null ? detail.price : "-"}}</span>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <div class="font-biggest font-weight text-primary mb16">基本信息：</div>
                    <div class="mb16">
                        <span>商品编码：</span>
                        <span class="text-color-45">{{detail.goodsNo || "-"}}</span>
                    </div>
                    <div class="mb16">
                        <span>商品条形码：</span>
                        <span class="text-color-45">{{detail.goodsBarCode || "-"}}</span>
                    </div>
                    <div class="mb16">
                        <span>商品名称：</span>
                        <span class="text-color-45">{{detail.goodsName || "-"}}</span>
                    </div>
                    <div class="mb16">
                        <span>商品规格：</span>
                        <span class="text-color-45">{{detail.goodsSpecification || "-"}}</span>
                    </div>
                    <div class="mb16">
                        <span>商品分组：</span>
                        <span class="text-color-45">{{goodsCate.categoryName || "-"}}</span>
                    </div>
                    <div class="mb16">
                        <span>基本单位：</span>
                        <span class="text-color-45">{{goodsUnit.goodsUnit || "-"}}</span>
                    </div>
                    <div>
                        <span>使用类型：</span>
                        <span class="text-color-45">{{['', '售卖', '自用'][detail.useType]}}</span>
                    </div>
                </template>
                <a-divider></a-divider>
            </a-spin>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    export default {
        name: 'materiel-detail',
        components: {},
        props: {},
        data() {
            return {
                spinning: false,
                detail: {},
                goodsCate: {},
                goodsUnit: {}
            };
        },
        watch: {
            shopId() {
                this.$router.back();
            }
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            /**
             * @getGoodsDetail 物料管理-【物料详情】
             */
            getGoodsDetail() {
                if (!this.shopId) {
                    return false;
                }
                let { id } = this.$route.params;
                this.spinning = true;
                this.$api.newStorage.kingDiskMaterielDetail({
                    query: {
                        goodsNo: id,
                        shopId: this.shopId
                    }
                }).then(res => {
                    this.spinning = false;
                    this.detail = res;
                });
            },
            /**
             * @kingDiskGoodsDetail 金蝶库存管理-【库存详情】
             */
            kingDiskGoodsDetail() {
                if (!this.shopId) {
                    return false;
                }
                let { id } = this.$route.params;
                this.spinning = true;
                this.$api.newStorage.kingDiskGoodsDetail({
                    query: {
                        id,
                        shopId: this.shopId
                    }
                }).then(res => {
                    this.spinning = false;
                    this.detail = res;
                });
            },
            /**
            /**
             * @getSelfGoodsDetail 自有库存管理-【库存详情】
             */
            getSelfGoodsDetail() {
                if (!this.shopId) {
                    return false;
                }
                let { id } = this.$route.params;
                this.spinning = true;
                this.$api.newStorage.selfGoodsDetail({
                    query: {
                        id,
                        shopId: this.shopId
                    }
                }).then(res => {
                    this.spinning = false;
                    this.detail = res;
                    this.getGoodsCateList();
                    this.getGoodsUnitList();
                });
            },
            /**
             * @getIntoStorageGoodsDetail 单个商品入库商品详情
             */
            getIntoStorageGoodsDetail() {
                let { id } = this.$route.params;
                this.spinning = true;
                this.$api.newStorage.selfGoodsGetInfo({
                    query: {
                        id
                    }
                }).then(res => {
                    this.spinning = false;
                    this.detail = res;
                    this.getGoodsCateList();
                    this.getGoodsUnitList();
                });
            },
            /**
             * @getGoodsCateList 获取商品类别
             */
            getGoodsCateList() {
                this.$api.newStorage.getSelfGoodsCateList({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (Boolean(res)) {
                        let goodsCate = res.find(item => item.id === this.detail.goodsCategoryId);
                        if (!Boolean(goodsCate)) {
                            return false;
                        }
                        this.goodsCate = res.find(item => item.id === this.detail.goodsCategoryId);
                    }
                });
            },
            /**
             * @getGoodsUnitList 获取单位列表
             */
            getGoodsUnitList() {
                this.$api.newStorage.getSelfGoodsUnitList({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (Boolean(res)) {
                        let goodsUnit = res.find(item => item.id === this.detail.goodsUnitId);
                        if (!Boolean(goodsUnit)) {
                            return false;
                        }
                        this.goodsUnit = res.find(item => item.id === this.detail.goodsUnitId);
                    }
                });
            },
        },
        beforeCreate() {
        },
        created() {},
        mounted() {
            let { sysType } = this.$route.params;
            if (sysType === 1) {
                //金蝶物料
                this.getGoodsDetail();
            } else if(sysType === 2) {
                // 自有库存
                this.getSelfGoodsDetail();
            } else if(sysType === 3) {
                // 自有库存
                this.kingDiskGoodsDetail();
            } else if(this.$route.name === 'materielGoodsDetail') {
                this.getIntoStorageGoodsDetail();
            }
        },
    };
</script>
<style lang="scss">
    .materiel-detail {
        background-color: #fff;
        padding: 24px;
        min-height: 70vh;
    }
</style>
